import { render, staticRenderFns } from "./VRequest.vue?vue&type=template&id=7157aea1&"
import script from "./VRequest.vue?vue&type=script&lang=js&"
export * from "./VRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports